import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { FormControl } from '@angular/forms';

import { RootService } from '../../service/root.service';

import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor } from '@angular/forms';

export function validateEmail(c) {
    if(!c.dirty){
        return null;
    }
    let EMAIL_REGEXP = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;

    return (EMAIL_REGEXP.test(c.value)) ? null : {validateEmail: true};
}

@Component({

    selector: 'aFormEmail,[aFormEmail]',
    templateUrl: './aFormEmail.component.html',
    styleUrls: ['./aFormEmail.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormEmailComponent, multi: true },
        { provide: NG_VALIDATORS, useExisting: AFormEmailComponent, multi: true },
    ]
})
export class AFormEmailComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() cClass;
    @Input() icon;
    @Input() disabled;
    value;
    model;
    formControl;
    _onChange = (value: any) => { };

    registerOnChange(fn) {
        this._onChange = fn;
    }

    registerOnTouched() { }
    writeValue(value: any) {
        this.value = value;
    }
    
    validate(c: FormControl) {
        this.formControl = c;
        return validateEmail(c);
    }
    constructor(public rootService:RootService) {

    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormEmail/aFormEmail.component.ts